module.exports = __webpack_public_path__ + "0f3fe990e92661e8ab94cdea8b3a1022.svg";